import React from 'react'
import 'moment/locale/zh-cn';
import zh_CN from 'antd/lib/locale-provider/zh_CN';
import {Path} from "../../../../public/path";
import {FetchUtil} from "../../../../public/fetch_util";
import Util, {regIdCard, checkEmail, checkMobile} from "../../../../public/utils";
import {
    Button,
    Col,
    ConfigProvider,
    DatePicker,
    Input,
    InputNumber,
    Message,
    Modal,
    Popconfirm,
    Popover,
    Radio,
    Row,
    Select,
    Table,
    Tooltip,
} from 'antd';
import SelectA from '../../../../cmpts/ant/Select'
import {Link} from "react-router-dom";
import SearchItems, {ItemType} from "../../../../cmpts/search/SearchItems";
import DataItem from "../../../../cmpts/dataStats/DataItem";
import DataTitle from "../../../../cmpts/dataStats/DataTitle";
import Api from "../../../../public/api";
import {URL_MXD_BOOST_ORDER_UPDATEFILLINFO, URL_MXD_GROUPBUY_ORDER_QUERY_EXPORT} from '../../../../public/variables'
import Price from "../../../prizeunlock/common/Price";
import ZkSearchGroup from "../../../../common/search/zkSearchGroup";
import ZkInput from "../../../../common/search/zkInput";
import ZkSelect from "../../../../common/search/zkSelect";
import ZkDateRange from "../../../../common/search/zkDateRange";
import ZkTable from "../../../../common/table/zkTable";
import ZkHeadText from "../../../../common/table/zkHeadText";
import {Closed, Completed, Delivered, PendingGroup, PendingSend} from "../../../../common/market/zkOrderStatus";
import ZkOptBtns from "../../../../common/table/zkOptBtns";
import ZkModal from "../../../../common/modal/zkModal";
import Store from "../../../../store";

const {RangePicker} = DatePicker;
const Option = Select.Option;
const RadioGroup = Radio.Group;

const limitDecimals = (value) => {
    const reg = /^(\-)*(\d+)\.(\d\d).*$/;
    if (typeof value === 'string') {
        return !isNaN(Number(value)) ? value.replace(reg, '$1$2.$3') : ''
    } else if (typeof value === 'number') {
        return !isNaN(value) ? String(value).replace(reg, '$1$2.$3') : ''
    } else {
        return ''
    }
};

const DataKeys = {
    totalOrder: 'totalOrder',
    orderPayAmount: 'orderPayAmount',
    levelOneRebate: 'levelOneRebate',
    levelTwoRebate: 'levelTwoRebate',
    realIncome: 'realIncome',
};

const DataItemMetaData = {
    [DataKeys.totalOrder]: {
        labelText: '活动总订单数',
        unitText: '单',
        tooltip: '当前活动总的订单笔数',
        circleColor: "#0C8EFFFF"
    },
    [DataKeys.orderPayAmount]: {
        labelText: '销售额',
        unitText: '元',
        tooltip: '当前活动总的收款金额',
        circleColor: "#6CC8EC"
    },
    [DataKeys.levelOneRebate]: {
        labelText: '一级返现',
        unitText: '元',
        tooltip: '当前活动一级返现总金额',
        circleColor: "#9270CA"
    },
    [DataKeys.levelTwoRebate]: {
        labelText: '二级返现',
        unitText: '元',
        tooltip: '当前活动二级返现总金额',
        circleColor: "#FF9D4D"
    },
    [DataKeys.realIncome]: {
        labelText: '实收金额',
        unitText: '元',
        tooltip: '当前活动扣除手续费和返现之后的实收金额',
        circleColor: "#0C8EFFFF"
    },
}

let arr = 'general_group_order_management'
let arr1 = 'general_group_order_management1'
let currentPageNum=1

class OrderList extends React.Component {
    constructor(props) {
        super(props);
        this.changePage = this.changePage.bind(this);
        this.orderFillInfoChange = this.orderFillInfoChange.bind(this);
        this.getColums = this.getColums.bind(this);
        this.getSameColums = this.getSameColums.bind(this);
        this.getOrderList = this.getOrderList.bind(this);
        this.state = {
            showGroup: false,
            groupId: '',
            orderList: [],//table list
            pagInfo: {
                pageNum: 1,
                pageSize: 10,
                total: null,
                pages: ''
            },
            groupPageInfo: {
                pageNum: 1,
                pageSize: 10,
                total: null,
                pages: ''
            },
            showYD: true,
            list: [],
            //    筛选字段
            taskList: [],//活动下拉列表的值
            channelList: [
                {
                    channelId: 0,
                    channelName: '全部渠道'
                }
            ], //渠道下拉列表

            timeList: [],
            timeType: null,

            queryParams: {
                pageSize: 10,
                pageNum: 1,
                groupbuyType: this.isLadder() ? 2 : 1
            },
            bodyData: {
                groupbuyId: Util.getActivityId() == 0 ? -1 : Util.getActivityId(),
                orderId: null,
                nickName: '',
                orderStatus: 9,
                startTime: '',
                endTime: ''
            },
            editModalInfo: [], //编辑采集信息

            orderStat: {
                totalOrder: 0,//	订单总数
                orderPayAmount: 0, //	销售额 单位分
                levelOneRebate: 0, //一级返现 单位分
                levelTwoRebate: 0, //	二级返现 单位分
                realIncome: 0, //实收金额 单位分
            },
            sendBody: {
                deliveryMode: 1, //1 快递发货 2 无需物流
                trackingNo: '', //快递单号
                companyName: '', //快递公司
                orderId: '', //订单id
            },
            exportVisible: false, // 导出modal
            exportData: {
                groupbuyId: -1,
                orderStatus: 9,
                startTime: '',
                endTime: '',
                type: 1
            },
            sameParams: {
                groupId: 0,
            }
        };
        this.defaultParams = {
            bargainId: 0,
            timeRange: {
                timeType: 0,
                startDate: new Date().getTime()
            }
        };
        this.statusList = [
            {
                name: '全部',
                status: 9,
                // },{
                //     name: '待支付',
                //     status: '0',
            }, {
                name: '待发货',
                status: 1,
            }, {
                name: '已发货',
                status: 2,
            }, {
                name: '已完成',
                status: 3,
            }, {
                name: '拼团中',
                status: 4,
            }, {
                name: '已退款',
                status: 5,
            }, {
                name: '已关闭',
                status: -3,
            },
        ];
    }

    componentWillMount() {
        this.initActivityList(); //活动列表
        // let str = Store.getQueryParams(arr)
        // let str1 = Store.getQueryParams(arr1)
        // if(this.props.groupBooktype == 'common'){
        //     if(str && str.params){
        //         this.setState({
        //             bodyData:str.params
        //         })
        //     }
        //     if(str && str.pageNum){
        //         currentPageNum = str.pageNum
        //     }
        // }else if(this.props.groupBooktype == 'isCommon'){
        //     if(str1 && str1.params){
        //         this.setState({
        //             bodyData:str1.params
        //         })
        //     }
        //     if(str1 && str1.pageNum){
        //         currentPageNum = str1.pageNum
        //     }
        // }
    }

    componentDidMount() {
        // this.initSelectData()

    }

    /**
     * 获取活动列表
     */
    initActivityList() {
        Api.getGroupBuyActList(this.props.type, (data) => {
            let arr = data.list;
            arr.unshift({
                groupbuyId: -1,
                groupbuyName: '全部活动',
            });
            this.setVal('taskList', arr);
        })
    }

    /**
     * 获取订单列表
     */
    getOrderList(queryParams, pageNum, pageSize) {
        currentPageNum = pageNum

        // if(this.props.groupBooktype == 'common'){
        //     Store.setAddFriendQueryParams(arr,this.state.bodyData,currentPageNum)
        // }else if(this.props.groupBooktype == 'isCommon'){
        //     Store.setAddFriendQueryParams(arr1,this.state.bodyData,currentPageNum)
        // }

        let params = {
            pageNum: pageNum,
            pageSize: pageSize,
            groupbuyType: this.isLadder() ? 2 : 1,
        };
        return new Promise((resolve) => {
            Api.getGroupBuyOrderList(params, queryParams, (data) => {
                resolve(data)
            }, () => {
            })
        });
    }

    shwoSameGroupList(id) {
        this.sameGroupOrderList.show();
        this.setState({
            sameParams: {
                groupId: id
            }
        });
    }

    getGroupDataList(params, pageNum, pageSize) {
        let groupId = params.groupId;
        if (groupId > 0) {
            return new Promise((resolve) => {
                Api.getGroupBuyOrderGroup(groupId, (data) => {
                    resolve(data);
                }, (error) => {
                    Message.error('获取同团订单数据失败')
                })
            });
        }

    }

    transformData(data, params) {
        let timeType = params.timeRange.timeType;
        let showYD = false;
        if (timeType == 0) { //今日数据
            showYD = true;
        }
        let list = data.list;
        // let totalData = data.totalData;
        let yDayData = null;
        let totalData = data;
        let statsData = {};
        for (let dataKey in DataKeys) {
            if (DataItemMetaData[dataKey]) {
                statsData[this.getDataItemName(dataKey)] = {
                    labelText: DataItemMetaData[dataKey].labelText,
                    ydLabelText: '昨日' + DataItemMetaData[dataKey].labelText,
                    value: totalData[dataKey],
                    ydValue: yDayData ? yDayData[dataKey] : null,
                    unitText: DataItemMetaData[dataKey].unitText,
                    showYD: showYD,
                    tooltip: DataItemMetaData[dataKey].tooltip,
                    circleColor: DataItemMetaData[dataKey].circleColor,
                };
            }
        }
        this.setState({
            showYD: showYD,
            statsData: statsData
        });
    }

    getId(key, val) {
        let bodyData = this.state.bodyData;
        bodyData[key] = val;
        this.setVal('bodyData', bodyData);
    }

    setVal(key, val) {
        this.setState({
            [key]: val
        })
    }

    timeChange(val) {
        if (val && val.length == 2) {
            let begin = val[0].valueOf();
            let end = val[1].valueOf();
            let bodyData = this.state.bodyData;
            bodyData.startTime = begin;
            bodyData.endTime = end;
            this.setVal('bodyData', bodyData);
        }
    }

    exportTimeChange(val) {
        if (val && val.length == 2) {
            let begin = val[0].valueOf();
            let end = val[1].valueOf();
            let exportData = this.state.exportData;
            exportData.startTime = begin;
            exportData.endTime = end;
            this.setVal('exportData', exportData);
        }
    }

    getDataItemName(key) {
        return key + 'DataItem';
    }

    changePage(pageNum, pageSize) {
        let pagInfo = this.state.pagInfo;
        pagInfo.pageNum = pageNum;
        pagInfo.pageSize = pageSize;
        let query = {
            pageSize: pageSize,
            pageNum: pageNum,
            groupbuyType: this.isLadder() ? 2 : 1
        };
        this.setVal('pagInfo', pagInfo);
    }

    changeGroupPage(pageNum, pageSize) {
        let pagInfo = this.state.groupPageInfo;
        pagInfo.pageNum = pageNum;
        pagInfo.pageSize = pageSize;
        let query = {
            pageSize: pageSize,
            pageNum: pageNum,
            groupbuyType: this.isLadder() ? 2 : 1
        };
        this.setVal('groupPageInfo', pagInfo);
        this.getGroupDataList(this.state.groupId);
    }

    inputChangeBodyDataEvent(key, e) {
        let bodyData = this.state.bodyData;
        bodyData[key] = e.target.value;
        this.setVal('bodyData', bodyData);
    }

    inputChangeBodyData(key, e) {
        let bodyData = this.state.bodyData;
        if (e.target.value) {
            bodyData[key] = Number(e.target.value);
        } else {
            bodyData[key] = null
        }

        this.setVal('bodyData', bodyData);
    }

    isLadder() {
        if (this.props.type == 'ladder') {
            return true;
        }
        return false;
    }


    query(type,params) {
        if(type == 'reset'){
            params.orderStatus = 9
            params.groupbuyId = -1
        }
        let bodyData = this.state.bodyData;
        bodyData.groupbuyId = params.groupbuyId;
        bodyData.orderId = params.orderId;
        bodyData.nickName = params.nickName;
        bodyData.orderStatus = params.orderStatus;
        if (params.timeRange.length == 2) {
            bodyData.startTime = params.timeRange[0];
            bodyData.endTime = params.timeRange[1];
        } else {
            bodyData.startTime = '';
            bodyData.endTime = '';
        }
        this.setState({
            bodyData: bodyData
        },()=>{
            // if(this.props.groupBooktype == 'common'){
            //     Store.setAddFriendQueryParams(arr,this.state.bodyData,currentPageNum)
            // }else if(this.props.groupBooktype == 'isCommon'){
            //     Store.setAddFriendQueryParams(arr1,this.state.bodyData,currentPageNum)
            // }
        })
    }

    getBuyerFillInfo(orderId, visible) {
        if (visible) {
            Api.getGoodsOrderBuyerFillInfo(orderId, (data) => {
                this.setState({
                    buyerFillInfo: data
                })
            }, (error) => {
                this.setState({
                    buyerFillInfo: []
                })
            })
        } else {
            this.setState({
                buyerFillInfo: []
            })
        }
    }

    showEditorModal(index, id, info) { //编辑用户采集信息
        this.setVal('editModalVisible', true);
        this.setVal('editModalInfo', JSON.parse(info));
        this.setVal('orderId', id);
        this.setVal('orderInfoIndex', index);
    }

    orderFillInfoChange(key, index, e) {
        let editModalInfo = this.state.editModalInfo;
        editModalInfo[index].desc = key;
        editModalInfo[index].value = e.target.value;
        this.setVal('editModalInfo', editModalInfo);
    }

    hideModal(key) {
        this.setVal('editModalInfo', []);
        this.setVal([key], false);
    }

    editOrderInfo() {
        let fillInfo = this.state.editModalInfo;
        let orderId = this.state.orderId;
        //    判断数据
        for (let i = 0; i < fillInfo.length; i++) {
            let item = fillInfo[i];
            if (Util.isEmpty(item.value)) {
                Message.error('请输入' + item.desc);
                return false;
            }
            if (item.type == 1) {
                if (!checkMobile(item.value)) {
                    Message.error('请输入正确的' + item.desc);
                    return false;
                }
            } else if (item.type == 3) {
                if (!Util.checkDateTime(item.value)) {
                    Message.error('请输入正确的' + item.desc);
                    return false;
                }
            } else if (item.type == 4) { //数字

            } else if (item.type == 5) {
                if (!regIdCard(item.value)) {
                    Message.error('请输入正确的' + item.desc);
                    return false;
                }
            } else if (item.type == 6) {
                if (!checkEmail(item.value)) {
                    Message.error('请输入正确的' + item.desc);
                    return false;
                }
            }
        }
        Api.doPost(URL_MXD_BOOST_ORDER_UPDATEFILLINFO, 'json', {fillInfo, orderId}, () => {
            Message.success('编辑成功');
            this.setVal('editModalVisible', false);
            this.listTable.refresh();
        }, () => {
            Message.warning('编辑失败,请稍后再试');
        })

    }


    showModal(key) {
        this.setVal([key], true);
    }

    showSendModal(id) {
        let sendBody = this.state.sendBody;
        sendBody.orderId = id;
        this.setState({
            sendBody: sendBody,
            sendVisible: true
        });
    }

    sendTypeChange(e) {
        let sendBody = this.state.sendBody;
        sendBody.deliveryMode = e.target.value;
        if (e.target.value == 2) {
            sendBody.companyName = '';
            sendBody.trackingNo = '';
        }
        this.setState({
            sendBody: sendBody
        })
    }

    downTypeChange(e) {
        let exportData = this.state.exportData;
        exportData.type = e.target.value;
        this.setVal('exportData', exportData)
    }

    sendInfoChange(key, e) {
        let sendBody = this.state.sendBody;
        sendBody[key] = e.target.value;
        this.setState({
            sendBody: sendBody
        });
    }

    editSendInfo() {
        let sendBody = this.state.sendBody;
        if (sendBody.deliveryMode == 1) {
            if (Util.isEmpty(sendBody.companyName)) {
                Message.error('快递公司不能为空');
                return false;
            }
            if (Util.isEmpty(sendBody.trackingNo)) {
                Message.error('快递单号不能为空');
                return false;
            }
        }
        Api.getDisTriOrderDelivery(sendBody, () => {
            Message.success('发货成功');
            this.setVal('sendVisible', false)
            this.listTable.refresh();
        }, () => {
            Message.error('发货失败，请稍后重试');
        })
    }

    exportData() {
        this.hideModal('exportVisible')
        let arr = [];
        arr.push('groupbuyId=' + this.state.exportData.groupbuyId);
        arr.push('orderStatus=' + this.state.exportData.orderStatus);
        arr.push('type=' + this.state.exportData.type);
        arr.push('startTime=' + this.state.exportData.startTime);
        arr.push('endTime=' + this.state.exportData.endTime);
        arr.push('groupbuyType=' + (this.isLadder() ? 2 : 1));
        let str = arr.join('&');
        Util.downLoadFile(URL_MXD_GROUPBUY_ORDER_QUERY_EXPORT + '?' + str);
    }

    getExportId(key, val) {
        let exportData = this.state.exportData;
        exportData[key] = val;
        this.setVal('exportData', exportData);
    }

    getSameColums() {
        return [
            {
                dataIndex: 'orderId',
                title: '订单编号',
                fixed: 'left',
                width: '120px',
                render: (text, record) => (
                    <span>{text}</span>
                )
            },
            {
                dataIndex: 'groupbuyName',
                title: '活动信息',
                width: '230px',
                render: (text, record, index) => (
                    <ZkHeadText headUrl={record.coverImgUrl} headText={text}/>
                )
            },
            {
                dataIndex: 'payAmount',
                title: '支付金额',
                render: (text, record, index) => (
                    <Price price={record.payAmount}/>
                )
            },
            {
                dataIndex: 'nickName',
                title: '购买用户',
                width: '170px',
                render: (text, record, index) => (
                    <div>
                        <span className={'qyheadImgInfo'}>
                            <img className='images' src={record.headImgUrl}/>
                            <div className={'captainWrapper'}>
                                <span>{text}</span>
                                {record.memberType == 0 ? <span className={'captain'}>团长订单</span> : ''}
                            </div>
                        </span>

                    </div>
                )
            },
            {
                dataIndex: 'orderTime',
                title: '下单时间',
                width: '200px',
                render: (text, record) => (
                    <span>{new Date(record.orderTime).format('yyyy-MM-dd hh:mm')}</span>
                )
            },
            {
                dataIndex: 'getInfoStatus',
                title: '采集信息',
                render: (val, record) => record.leaveWord != '[]' && val == 1 ?
                    <Popover placement="top"
                             trigger="hover"
                             overlayClassName='ant-mxd-tooltip'
                             getPopupContainer={triggerNode => triggerNode.parentNode}
                             title={null}
                             content={
                                 <ul>
                                     {
                                         (JSON.parse(record.leaveWord)).map(function (item) {
                                             return <li className='fillInfoWraper'>
                                                 <label> {item.desc}:</label>
                                                 {
                                                     item.value
                                                 }
                                             </li>
                                         })
                                     }
                                 </ul>
                             }>
                        <span className='mxd-cursor-pointer text-primary'>已填写</span>
                    </Popover> :
                    ''
            },
            {
                dataIndex: 'logisticsStatus',
                title: '物流信息',
                render: (text, record, index) => (
                    <div>
                        {
                            text == 0 ? '' : ''
                        }
                        {
                            text == 1 && record.logisticsInfo ? <>
                                {
                                    record.logisticsInfo.deliveryMode == 1 ?
                                        <ul>
                                            <li>{record.logisticsInfo.companyName}</li>
                                            <li>{record.logisticsInfo.trackingNo}</li>
                                        </ul> : '无需物流'
                                }
                            </> : ''
                        }
                    </div>
                )
            },
            {
                dataIndex: 'status',
                title: '订单状态',
                render: (status) => (
                    <div>
                        {status == 0 ? <span className="text-fail">待支付</span> : ''}
                        {status == 1 ? <PendingSend/> : ''}
                        {status == 2 ? <Delivered/> : ''}
                        {status == 3 ? <Completed/> : ''}
                        {status == 4 ? <PendingGroup/> : ''}
                        {status == -3 ? <Closed/> : ''}
                    </div>

                )
            },
            {
                dataIndex: 'key',
                title: '操作',
                align: 'center',
                fixed: 'right',
                width: '64px',
                render: (text, record, index) => (
                    <ZkOptBtns>
                        <span className={'text-primary'}>
                            <Link target=''
                                  to={(this.isLadder() ? Path.goGroupBuyLadderOrderDetail() : Path.goGroupBuyOrderDetail()) + record.orderId}>
                                详情
                            </Link>
                        </span>
                    </ZkOptBtns>
                )
            },
        ];
    }

    getColums() {
        return [
            {
                dataIndex: 'orderId',
                title: '订单编号',
                fixed: 'left',
                width: '120px',
                render: (text, record) => (
                    <span>{text}</span>
                )
            },
            {
                dataIndex: 'groupbuyName',
                title: '活动信息',
                width: '230px',
                render: (text, record, index) => (
                    <ZkHeadText headUrl={record.coverImgUrl} headText={text}/>
                )
            },
            {
                dataIndex: 'payAmount',
                title: '支付金额',
                render: (text, record, index) => (
                    <Price price={record.payAmount}/>
                )
            },
            {
                dataIndex: 'nickName',
                title: '购买用户',
                width: '170px',
                render: (text, record, index) => (
                    <div>
                        <span className={'qyheadImgInfo'}>
                            <img className='images' src={record.headImgUrl}/>
                            <div className={'captainWrapper'}>
                                <span>{text}</span>
                                {record.memberType == 0 ? <span className={'captain'}>团长订单</span> : ''}
                            </div>
                        </span>

                    </div>
                )
            },
            {
                dataIndex: 'orderTime',
                title: '下单时间',
                width: '200px',
                render: (text, record) => (
                    <span>{new Date(record.orderTime).format('yyyy-MM-dd hh:mm')}</span>
                )
            },
            {
                dataIndex: 'getInfoStatus',
                title: '采集信息',
                render: (val, record) => record.leaveWord != '[]' && val == 1 ?
                    <Popover placement="top"
                             trigger="hover"
                             overlayClassName='ant-mxd-tooltip'
                             title={null}
                             content={
                                 <ul>
                                     {
                                         (JSON.parse(record.leaveWord)).map(function (item) {
                                             return <li className='fillInfoWraper'>
                                                 <label> {item.desc}:</label>
                                                 {
                                                     item.value
                                                 }
                                             </li>
                                         })
                                     }
                                 </ul>
                             }>
                        <span className='mxd-cursor-pointer text-primary'>已填写</span>
                    </Popover> :
                    ''
            },
            {
                dataIndex: 'logisticsStatus',
                title: '物流信息',
                render: (text, record, index) => (
                    <div>
                        {
                            text == 0 ? '' : ''
                        }
                        {
                            text == 1 && record.logisticsInfo ? <>
                                {
                                    record.logisticsInfo.deliveryMode == 1 ?
                                        <ul>
                                            <li>{record.logisticsInfo.companyName}</li>
                                            <li>{record.logisticsInfo.trackingNo}</li>
                                        </ul> : '无需物流'
                                }
                            </> : ''
                        }
                    </div>
                )
            },
            {
                dataIndex: 'status',
                title: '订单状态',
                render: (status) => (
                    <div>
                        {status == 0 ? <span className="text-fail">待支付</span> : ''}
                        {status == 1 ? <PendingSend/> : ''}
                        {status == 2 ? <Delivered/> : ''}
                        {status == 3 ? <Completed/> : ''}
                        {status == 4 ? <PendingGroup/> : ''}
                        {status == -3 ? <Closed/> : ''}
                    </div>

                )
            },
            {
                dataIndex: 'key',
                title: '操作',
                align: 'center',
                fixed: 'right',
                width: '244px',
                render: (text, record, index) => (
                    <ZkOptBtns>
                        {
                            record.status == 1 ?
                                <span className={'text-primary'}
                                      onClick={this.showSendModal.bind(this, record.orderId)}>
                                    发货
                                </span> : <span className={'text-gray disable'}>
                                    发货
                                </span>
                        }
                        {
                            record.getInfoStatus == 1 ? <span className={'text-primary'}
                                                              onClick={this.showEditorModal.bind(this, index, record.orderId, record.leaveWord)}>
                                编辑信息
                            </span> : <span className={'text-gray disable'}>
                                    编辑信息
                                </span>
                        }
                        <span className={'text-primary'} onClick={this.shwoSameGroupList.bind(this, record.groupId)}>
                            同团订单
                        </span>
                        <span className={'text-primary'}>
                            <Link target='_blank'
                                  to={Path.goGroupBuyOrderDetail() + record.orderId}>
                                详情
                            </Link>
                        </span>
                    </ZkOptBtns>
                )
            },
        ];
    }

    render() {

        return (
            <>
                <ZkSearchGroup onOk={this.query.bind(this,'ok')}
                               onReset={this.query.bind(this,'reset')}
                               btnBlock={false}
                               otherBtns={<Button onClick={this.showModal.bind(this, 'exportVisible')}>导出</Button>}>
                    <ZkInput title='订单编号：' defaultValue={this.state.bodyData.orderId} valueKey='orderId' placeholder={'请输入订单编号'}/>
                    <ZkSelect title={'当前活动：'} valueKey='groupbuyId' defaultValue={this.state.bodyData.groupbuyId}>
                        {
                            this.state.taskList.map(function (item, index) {
                                return <Option value={item.groupbuyId}>{item.groupbuyName}</Option>
                            })
                        }
                    </ZkSelect>
                    <ZkInput title='购买用户：' defaultValue={this.state.bodyData.nickName} valueKey='nickName' placeholder={'请输入购买用户昵称'}/>
                    <ZkSelect title={'交易状态：'} valueKey='orderStatus'
                              defaultValue={this.state.bodyData.orderStatus}>
                        {
                            this.statusList.map(function (item, index) {
                                return <Option value={item.status}>{item.name}</Option>
                            })
                        }
                    </ZkSelect>
                    <ZkDateRange title='下单时间：' valueKey='timeRange' defaultValue={[this.state.bodyData.startTime,this.state.bodyData.endTime]}/>
                </ZkSearchGroup>
                <ZkTable ref={r => this.listTable = r} owncolumns={this.getColums} queryAction={this.getOrderList}
                         params={this.state.bodyData} baseProps={{scroll: {x: 1700}}} currentPageNum={currentPageNum}/>
                {/*订单客户信息编辑*/}
                <Modal
                    title="采集信息编辑"
                    visible={this.state.editModalVisible}
                    onOk={this.editOrderInfo.bind(this)}
                    okText={'保存'}
                    onCancel={this.hideModal.bind(this, 'editModalVisible')}
                >
                    <ul className='orderForm'>
                        {
                            this.state.editModalVisible && this.state.editModalInfo ? this.state.editModalInfo.map(function (item, index) {
                                return <li>
                                    <Row>
                                        <Col span={4}>
                                            <span className='span-line'>{item.desc}：</span>
                                        </Col>
                                        <Col span={20}>
                                            <Input placeholder={'请输入' + item.desc} value={item.value}
                                                   onChange={this.orderFillInfoChange.bind(this, item.desc, index)}/>
                                        </Col>
                                    </Row>
                                </li>
                            }, this) : ''
                        }
                    </ul>
                </Modal>
                {/*订单发货*/}
                <Modal
                    title="订单发货"
                    visible={this.state.sendVisible}
                    onOk={this.editSendInfo.bind(this)}
                    okText={'保存'}
                    onCancel={this.hideModal.bind(this, 'sendVisible')}
                >
                    {
                        this.state.sendVisible && this.state.sendBody ?
                            <div className={'send-row'}>
                                <Row>
                                    <Col span={4}>
                                        <span className='span-line'>订单编号：</span>
                                    </Col>
                                    <Col span={20}>
                                        <span className='span-line'>{this.state.sendBody.orderId}</span>
                                    </Col>
                                </Row>
                                <Row>
                                    <Col span={4}>
                                        <span className='span-line'>发货方式：</span>
                                    </Col>
                                    <Col span={20}>
                                        <RadioGroup name="sendType" value={this.state.sendBody.deliveryMode}
                                                    onChange={this.sendTypeChange.bind(this)}>
                                            <Radio value={1}>快递发货</Radio>
                                            <Radio value={2}>无需物流</Radio>
                                        </RadioGroup>
                                    </Col>
                                </Row>
                                {
                                    this.state.sendBody.deliveryMode == 2 ? '' : <div>
                                        <Row>
                                            <Col span={4}>
                                                <span className='span-line'>快递公司：</span>
                                            </Col>
                                            <Col span={20}>
                                                <Input placeholder='请输入快递公司' value={this.state.sendBody.companyName}
                                                       onChange={this.sendInfoChange.bind(this, 'companyName')}/>
                                            </Col>
                                        </Row>
                                        <Row>
                                            <Col span={4}>
                                                <span className='span-line'>快递单号：</span>
                                            </Col>
                                            <Col span={20}>
                                                <Input placeholder='请输入快递单号' value={this.state.sendBody.trackingNo}
                                                       onChange={this.sendInfoChange.bind(this, 'trackingNo')}/>
                                            </Col>
                                        </Row>
                                    </div>
                                }
                            </div> : ''
                    }
                </Modal>
                {/*导出*/}
                <Modal
                    title="导出"
                    visible={this.state.exportVisible}
                    onOk={this.exportData.bind(this)}
                    okText={'确认导出'}
                    onCancel={this.hideModal.bind(this, 'exportVisible')}
                >
                    <div className={'send-row'}>
                        <Row>
                            <Col span={4}>
                                <span className='span-line'>活动名称：</span>
                            </Col>
                            <Col span={20}>
                                <SelectA
                                    style={{minWidth: 350}}
                                    optionList={this.state.taskList}
                                    placeholder='全部活动'
                                    value={this.state.exportData.groupbuyId == -1 ? '全部活动' : this.state.exportData.groupbuyId}
                                    valueKey={'groupbuyId'}
                                    selected={this.getExportId.bind(this, 'groupbuyId')}
                                    optionKey={'groupbuyName'}
                                ></SelectA>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={4}>
                                <span className='span-line'>交易状态：</span>
                            </Col>
                            <Col span={20}>
                                <SelectA
                                    style={{minWidth: 350}}
                                    optionList={this.statusList}
                                    placeholder='全部活动'
                                    value={this.state.exportData.orderStatus == 9 ? '全部' : this.state.exportData.orderStatus}
                                    valueKey={'status'}
                                    selected={this.getExportId.bind(this, 'orderStatus')}
                                    optionKey={'name'}
                                ></SelectA>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={4}>
                                <span className='span-line'>下单日期：</span>
                            </Col>
                            <Col span={20}>
                                <div style={{width: '350px'}}>
                                    <ConfigProvider locale={zh_CN}>
                                        <RangePicker onChange={this.exportTimeChange.bind(this)}
                                                     defaultValue={this.state.exportData.startTime > 0 ? [new moment(this.state.exportData.startTime), new moment(this.state.exportData.endTime)] : [null, null]}
                                                     showTime
                                                     separator="至"/>
                                    </ConfigProvider>
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={4}>
                                <span className='span-line'>下载类型：</span>
                            </Col>
                            <Col span={20}>
                                <RadioGroup name="sendType" value={this.state.exportData.type}
                                            onChange={this.downTypeChange.bind(this)}>
                                    <Radio value={1}>所有活动订单合并到一个文件</Radio>
                                    <br/>
                                    <Radio value={2}>一个活动一个文件</Radio>
                                </RadioGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col span={23}>
                                <p className='red-text'>注意：如果你的订单量比较大，全部都导出会等待很长时间，请尽量根据活动名称、交易状态和下单日期进行筛选并导出</p>
                            </Col>
                        </Row>
                    </div>
                </Modal>
                <ZkModal ref={r => this.sameGroupOrderList = r} title="同团订单列表" width={1000}
                         footer={<Button onClick={() => {
                             this.sameGroupOrderList.hide()
                         }}>关闭</Button>}>
                    <div>
                        <ZkTable owncolumns={this.getSameColums}
                                 queryAction={this.getGroupDataList}
                                 params={this.state.sameParams} baseProps={{scroll: {x: 1700}}}/>
                    </div>
                </ZkModal>
            </>
        );
    }


}

export default OrderList